// extracted by mini-css-extract-plugin
export default {"closeIcon":"styles_closeIcon__mCTSi","dialogMobile":"styles_dialogMobile__ZBd9u","modal":"styles_modal__B04nE"};